import { Organization } from '@yuno/types'
import { useEffect, useState } from 'react'
import { storage, Item } from '../lib/storage'

export const useOrganization = (
  organizations?: Organization.Organization[],
) => {
  const [organization, setOrganization] = useState<Organization.Organization>()

  useEffect(() => {
    if (organizations?.length > 0) {
      const organizationListener = (
        organization: Organization.Organization,
      ) => {
        setOrganization(organization)
      }
      storage.on(Item.ORGANIZATION, organizationListener)
      setOrganization(
        storage.getItem<Organization.Organization>(Item.ORGANIZATION),
      )
      return () => {
        storage.off(Item.ORGANIZATION, organizationListener)
      }
    }
  }, [organizations])

  return { organization }
}
